import { serverDate } from '@etiquetachef/ui-shared/online';
const MS_DAY = 24 * 60 * 60 * 1000;

/**
 * Formata cohort month (yyyymm) → "MM/YYYY" para exibição.
 */
export function formatCohortMonth(yyyymm: string): string {
  if (!/^\d{6}$/.test(yyyymm)) return yyyymm;
  return `${yyyymm.slice(4, 6)}/${yyyymm.slice(0, 4)}`;
}

/**
 * Idade de um cohort em dias até `now`. Cohort yyyymm conta a partir
 * do dia 1 do mês. Útil para decidir se uma janela `dN` é "imatura"
 * (cohort ainda não viveu N dias).
 */
export function cohortAgeDays(yyyymm: string, now: Date = serverDate()): number {
  if (!/^\d{6}$/.test(yyyymm)) return 0;
  const yyyy = Number(yyyymm.slice(0, 4));
  const mm = Number(yyyymm.slice(4, 6)) - 1;
  const start = Date.UTC(yyyy, mm, 1);
  return Math.max(0, Math.floor((now.getTime() - start) / MS_DAY));
}

/**
 * `true` se o cohort ainda não maturou para a janela `windowDays`
 * (ex.: cohort de 20 dias atrás não maturou D90). UI deve renderizar
 * `—` em vez de número quando imatura.
 */
export function isCohortImmature(
  yyyymm: string,
  windowDays: number,
  now: Date = serverDate(),
): boolean {
  return cohortAgeDays(yyyymm, now) < windowDays;
}

/**
 * Mapeia retention 0..1 para cor HEX num gradiente azul→amarelo→vermelho.
 * 1 = retenção total (azul), 0 = todos churnaram (vermelho).
 */
export function retentionColor(retention: number): string {
  const r = Math.min(1, Math.max(0, retention));
  if (r >= 0.7) return '#1d4ed8'; // blue-700
  if (r >= 0.5) return '#3b82f6'; // blue-500
  if (r >= 0.3) return '#f59e0b'; // amber-500
  if (r >= 0.15) return '#f97316'; // orange-500
  return '#dc2626'; // red-600
}

/** Fração 0–1 → texto percentual (`0.42` → `42%`). */
export function formatRetentionPct(retention: number, fractionDigits = 0): string {
  return `${(retention * 100).toFixed(fractionDigits)}%`;
}
